export default "__VITE_ASSET__E8E73Apy__"